// src/Dashboard/pages/user/ArbitrageJudo/data/arbitrageJudoData.js

export const ARBITRAGE_CATEGORIES = [
  "Tous",
  "Bases",
  "Commandes",
  "Scores",
  "Règles 2025",
  "Sanctions",
  "Temps",
  "Commissaires",
  "Formation",
];

export const ARBITRAGE_SECTIONS = [
  {
    id: "role-arbitre",
    category: "Bases",
    kicker: "Sécurité & décisions",
    title: "Rôle de l’arbitre",
    summary:
      "L’arbitre assure la sécurité des combattants, applique les règles et attribue les décisions du combat.",
    image: "/img/arbitrage/arbitrage_judo_01_zlmwhp.jpg",
    items: [
      {
        title: "Les missions principales",
        paragraphs: [
          "Assurer la sécurité des combattants.",
          "Faire respecter les règles du judo.",
          "Attribuer les points et les pénalités.",
          "Déterminer le vainqueur du combat.",
        ],
      },
      {
        title: "Pourquoi c’est important ?",
        paragraphs: [
          "L’arbitrage garantit un combat équitable, sécurisé et conforme à l’esprit du judo.",
          "L’arbitre doit rester clair, calme et visible pour que les combattants, coachs et commissaires sportifs comprennent ses décisions.",
        ],
      },
    ],
  },
  {
    id: "commandes-arbitre",
    category: "Commandes",
    kicker: "Gestes & annonces",
    title: "Les principales commandes de l’arbitre",
    summary:
      "Hajime, Matte, Sore-made, Osaekomi et Toketa sont les annonces essentielles à connaître.",
    image: "/img/arbitrage/arbitrage_judo_06_h2yqp4.jpg",
    layout: "reverse",
    items: [
      {
        title: "Hajime : début ou reprise du combat",
        paragraphs: [
          "Hajime est le terme japonais utilisé pour commencer le combat ou le reprendre après une interruption.",
        ],
      },
      {
        title: "Matte : arrêt temporaire",
        paragraphs: [
          "Matte signifie que l’arbitre interrompt temporairement le combat.",
          "Les combattants doivent s’arrêter et attendre une nouvelle annonce.",
        ],
      },
      {
        title: "Sore-made : fin du combat",
        paragraphs: [
          "Sore-made indique la fin du combat.",
          "Après cette annonce, l’arbitre désigne le vainqueur.",
        ],
      },
      {
        title: "Osaekomi : début d’immobilisation",
        paragraphs: [
          "Osaekomi signifie qu’une immobilisation au sol est effective.",
          "Le chronomètre d’immobilisation est alors enclenché.",
        ],
      },
      {
        title: "Toketa : fin d’immobilisation",
        paragraphs: [
          "Toketa signifie que l’immobilisation est rompue.",
          "Le chronomètre d’immobilisation est arrêté.",
        ],
      },
    ],
  },
  {
    id: "scores-penalites",
    category: "Scores",
    kicker: "Points & pénalités",
    title: "Le système de points, avantages & pénalités",
    summary:
      "Ippon, Waza-ari, Yuko, Shido et Hansoku-make structurent le résultat du combat.",
    image: "/img/arbitrage/arbitrage_judo_04_o2hiap.webp",
    items: [
      {
        title: "Ippon : point complet",
        paragraphs: [
          "Ippon est le score le plus élevé en judo. Il donne une victoire immédiate.",
          "Il peut être accordé pour une projection répondant aux critères de contrôle, force et vitesse, pour une immobilisation complète, ou par abandon sur étranglement ou clé de bras autorisée.",
        ],
      },
      {
        title: "Waza-ari : avantage important",
        paragraphs: [
          "Waza-ari récompense une action forte mais qui ne remplit pas toutes les conditions de l’Ippon.",
          "Il peut aussi être accordé pour une immobilisation d’une durée suffisante mais non complète.",
          "Deux Waza-ari équivalent à Ippon.",
        ],
      },
      {
        title: "Yuko : avantage",
        paragraphs: [
          "Le Yuko est un avantage inférieur au Waza-ari.",
          "Il peut être accordé selon les règles appliquées lors de la compétition et notamment pour certaines actions ou durées d’immobilisation.",
        ],
      },
      {
        title: "Shido & Hansoku-make",
        paragraphs: [
          "Shido est une pénalité mineure.",
          "Hansoku-make est une disqualification.",
          "Les pénalités servent à sanctionner la passivité, les actions interdites, les sorties volontaires ou les comportements contraires à l’esprit du judo.",
        ],
      },
    ],
  },
  {
    id: "regles-2025",
    category: "Règles 2025",
    kicker: "Évolutions récentes",
    title: "Nouvelles règles d’arbitrage 2025",
    summary:
      "Les principales évolutions à retenir pour mieux comprendre les décisions en compétition.",
    image: "/img/arbitrage/image_arbitrage01.jpg",
    items: [
      {
        title: "Retour du Yuko",
        paragraphs: [
          "Le Yuko revient dans le système de notation.",
          "En ne-waza, cette valeur peut être donnée au bout de cinq secondes d’immobilisation selon le règlement appliqué.",
        ],
      },
      {
        title: "Utilisation de la tête",
        paragraphs: [
          "L’utilisation de la tête pour projeter ou se défendre est à nouveau autorisée.",
          "Dans la catégorie cadets, cette action est pénalisée d’un shido.",
        ],
      },
      {
        title: "Saisies sous la ceinture",
        paragraphs: [
          "Certaines saisies de veste sous la ceinture ou en haut de la cuisse intérieure sont autorisées.",
          "Si la saisie est réalisée de manière négative, un shido peut être donné.",
        ],
      },
      {
        title: "Kumikata et temps d’attaque",
        paragraphs: [
          "Une fois le kumikata installé, le combattant dispose de trente secondes pour lancer une attaque.",
        ],
      },
      {
        title: "Prise de l’ours",
        paragraphs: [
          "La prise de l’ours est autorisée.",
          "Si les bras ou les mains sont joints autour de l’adversaire, un shido peut être donné.",
        ],
      },
      {
        title: "Sortie non intentionnelle",
        paragraphs: [
          "Sortir de manière non intentionnelle de la surface de combat, en tachi-waza comme en ne-waza, donne lieu à Matte.",
        ],
      },
      {
        title: "Clés de bras dangereuses",
        paragraphs: [
          "Les clés de bras appliquées lors d’une projection avec risque élevé de blessure peuvent être sanctionnées par hansoku-make.",
          "Si le risque est faible et exécuté avec les deux mains sur un bras, l’arbitre peut dire Matte puis pénaliser d’un shido.",
        ],
      },
      {
        title: "Ne-waza et seoi-nage inversé",
        paragraphs: [
          "L’activité en ne-waza est prise en considération.",
          "Le seoi-nage inversé est à nouveau autorisé sauf chez les cadets où il est pénalisé d’un shido.",
        ],
      },
    ],
  },
  {
    id: "actions-interdites",
    category: "Sanctions",
    kicker: "Actions interdites",
    title: "Les actions interdites & sanctions",
    summary:
      "Les infractions peuvent mener à Shido ou Hansoku-make selon leur gravité.",
    image: "/img/arbitrage/arbitrage_judo_03_b1ibhn.jpg",
    layout: "reverse",
    items: [
      {
        title: "Infractions légères : Shido",
        paragraphs: [
          "Éviter intentionnellement de prendre le kumi-kata.",
          "Adopter une attitude défensive exagérée.",
          "Faire une fausse attaque.",
          "Saisir en pistolet ou en ourlet.",
          "Empêcher la saisie adverse en tenant les doigts ou le poignet.",
          "Défaire volontairement son judogi ou sa ceinture.",
          "Sortir volontairement de la zone de combat.",
          "Rompre la saisie adverse de manière interdite.",
        ],
      },
      {
        title: "Infractions graves : Hansoku-make",
        paragraphs: [
          "Toute action pouvant porter atteinte à l’intégrité physique de l’adversaire.",
          "Les techniques dangereuses ou contraires au règlement.",
          "Les comportements contraires à l’esprit du judo : insultes, gestes déplacés, coups volontaires ou refus d’obéir à l’arbitre.",
          "Le diving : projeter sa tête directement sur le tatami.",
        ],
      },
      {
        title: "Succession des Shido",
        paragraphs: [
          "Trois Shido successifs entraînent Hansoku-make et la victoire de l’adversaire.",
          "Un combattant peut reprendre les combats après un Hansoku-make par accumulation de Shido.",
          "Un combattant peut être disqualifié de la compétition pour une action contraire à l’esprit du judo.",
        ],
      },
    ],
  },
  {
    id: "temps-combat",
    category: "Temps",
    kicker: "Durées & Golden Score",
    title: "La durée des combats",
    summary:
      "La durée varie selon les catégories d’âge et les niveaux de compétition.",
    image: "/img/arbitrage/arbitrage_judo_07_mo5tqx.webp",
    items: [
      {
        title: "Temps de combat par catégorie",
        paragraphs: [
          "Mini-poussins et poussins : 1 min 30.",
          "Benjamins : 2 min.",
          "Minimes, cadets, juniors et seniors selon divisions : 3 min ou 4 min.",
          "Le temps de récupération correspond généralement à deux fois la durée du combat.",
        ],
      },
      {
        title: "Golden Score",
        paragraphs: [
          "Le Golden Score est une prolongation utilisée lorsque le temps réglementaire se termine sans vainqueur.",
          "Le premier combattant qui marque ou bénéficie d’une pénalité décisive remporte le combat.",
          "Le combat continue jusqu’à ce qu’une action décisive se produise.",
        ],
      },
    ],
  },
  {
    id: "table-arbitrage",
    category: "Commissaires",
    kicker: "Table & suivi combat",
    title: "Table d’arbitrage & commissaires sportifs",
    summary:
      "La table assure le suivi du score, du temps, des pénalités et du résultat officiel.",
    image: "/img/arbitrage/arbitrage_judo_05_yce4cw.webp",
    layout: "reverse",
    items: [
      {
        title: "Enregistrement des scores",
        paragraphs: [
          "Les commissaires sportifs enregistrent les points et les pénalités en temps réel.",
          "Ils suivent le temps de combat, le temps d’immobilisation et le Golden Score.",
          "Ils assistent l’arbitre pour garantir la bonne application des décisions.",
        ],
      },
      {
        title: "Importance de la table",
        paragraphs: [
          "La table de marquage garantit une gestion claire, équitable et transparente du combat.",
          "Les commissaires sportifs travaillent avec les arbitres pour assurer la précision des résultats.",
        ],
      },
    ],
  },
  {
    id: "formation-arbitres",
    category: "Formation",
    kicker: "Progression",
    title: "La formation des arbitres",
    summary:
      "Les écoles d’arbitrage permettent de former les jeunes arbitres et commissaires sportifs.",
    image: "/img/arbitrage/arbitrage_judo_02_rpacmx.jpg",
    items: [
      {
        title: "Écoles d’arbitrage",
        paragraphs: [
          "Les comités départementaux organisent généralement des écoles d’arbitrage pour former les arbitres et commissaires sportifs.",
          "Ces formations permettent d’apprendre les gestes, les annonces, le règlement et la posture attendue en compétition.",
        ],
      },
      {
        title: "Niveaux d’arbitrage",
        paragraphs: [
          "Les arbitres peuvent évoluer sur plusieurs niveaux : départemental, régional, national puis international.",
          "La progression dépend de la formation, de l’expérience, des évaluations et de la participation aux compétitions.",
        ],
      },
    ],
  },
];

export const ARBITRAGE_QUIZ_QUESTIONS = [
  {
    id: 1,
    question: "Que signifie Hajime ?",
    options: [
      "Début ou reprise du combat",
      "Fin du combat",
      "Début d’immobilisation",
      "Disqualification",
    ],
    answer: "Début ou reprise du combat",
    explanation:
      "Hajime est l’annonce utilisée pour commencer ou reprendre le combat.",
  },
  {
    id: 2,
    question: "Que signifie Matte ?",
    options: [
      "Arrêt temporaire du combat",
      "Victoire immédiate",
      "Avantage technique",
      "Temps d’immobilisation terminé",
    ],
    answer: "Arrêt temporaire du combat",
    explanation:
      "Matte interrompt temporairement le combat. Les combattants doivent s’arrêter.",
  },
  {
    id: 3,
    question: "Quelle annonce indique la fin du combat ?",
    options: ["Sore-made", "Toketa", "Osaekomi", "Hajime"],
    answer: "Sore-made",
    explanation:
      "Sore-made signifie que le combat est terminé. L’arbitre désigne ensuite le vainqueur.",
  },
  {
    id: 4,
    question: "Que signifie Osaekomi ?",
    options: [
      "Début d’une immobilisation",
      "Fin d’une immobilisation",
      "Pénalité mineure",
      "Début du Golden Score",
    ],
    answer: "Début d’une immobilisation",
    explanation:
      "Osaekomi annonce qu’une immobilisation est effective et que le chronomètre est lancé.",
  },
  {
    id: 5,
    question: "Que signifie Toketa ?",
    options: [
      "Fin d’une immobilisation",
      "Début du combat",
      "Victoire par Ippon",
      "Sortie de tapis",
    ],
    answer: "Fin d’une immobilisation",
    explanation:
      "Toketa annonce que l’immobilisation est rompue et que le chronomètre d’immobilisation s’arrête.",
  },
  {
    id: 6,
    question: "Quel score donne une victoire immédiate ?",
    options: ["Ippon", "Waza-ari", "Yuko", "Shido"],
    answer: "Ippon",
    explanation:
      "Ippon est le score le plus élevé. Il met immédiatement fin au combat.",
  },
  {
    id: 7,
    question: "Que se passe-t-il avec deux Waza-ari ?",
    options: [
      "Ils équivalent à Ippon",
      "Ils donnent un Shido",
      "Ils lancent le Golden Score",
      "Ils ne comptent pas",
    ],
    answer: "Ils équivalent à Ippon",
    explanation:
      "Deux Waza-ari obtenus par le même combattant équivalent à Ippon.",
  },
  {
    id: 8,
    question: "Qu’est-ce qu’un Shido ?",
    options: [
      "Une pénalité mineure",
      "Un point complet",
      "Une annonce de reprise",
      "Une immobilisation",
    ],
    answer: "Une pénalité mineure",
    explanation:
      "Shido est une pénalité donnée pour une faute mineure ou une attitude contraire au règlement.",
  },
  {
    id: 9,
    question: "Que peut entraîner Hansoku-make ?",
    options: [
      "La disqualification",
      "Un simple avertissement",
      "Un Yuko",
      "Une reprise du combat",
    ],
    answer: "La disqualification",
    explanation:
      "Hansoku-make correspond à une disqualification, selon la situation.",
  },
  {
    id: 10,
    question: "Quel est le rôle principal des commissaires sportifs ?",
    options: [
      "Suivre le score, le temps et les pénalités",
      "Coach­er les combattants",
      "Choisir les catégories de poids",
      "Remplacer l’arbitre central",
    ],
    answer: "Suivre le score, le temps et les pénalités",
    explanation:
      "Les commissaires sportifs enregistrent les scores, pénalités, temps de combat et temps d’immobilisation.",
  },
];